import {CanActivateFn, Router} from '@angular/router';
import { inject } from '@angular/core';
import {fetchAuthSession} from "aws-amplify/auth";


export const authGuard: CanActivateFn = (route, state) => {

  console.log("Auth guard invoked for url: ", state.url) ;

  const router = inject(Router);

  return fetchAuthSession()
    .then((session) => {

      console.log("Auth session fetched: ", session);

      if (session?.tokens) {
        return true ;
      } else {
        const url = router.parseUrl('/signin');
        url.queryParams = {
          returnUrl: state.url
        }
        console.log("No valid session, redirecting to signin: ", url.toString()) ;
        return url ;
      }
    }) ;
};